export const ROLE_SYSTEM_ADMIN = 0;
export const ROLE_ADMIN = 1;

export const RG_ALL_ROLES = [ROLE_SYSTEM_ADMIN, ROLE_ADMIN];
export const RG_SYSTEM_ADMIN = [ROLE_SYSTEM_ADMIN];
export const RG_ADMIN = [ROLE_ADMIN];